import { render, staticRenderFns } from "./ImportModal.vue?vue&type=template&id=15049b3b&scoped=true&"
import script from "./ImportModal.vue?vue&type=script&lang=js&"
export * from "./ImportModal.vue?vue&type=script&lang=js&"
import style0 from "./ImportModal.vue?vue&type=style&index=0&id=15049b3b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15049b3b",
  null
  
)

export default component.exports